import React from 'react';
import ReactDOM from 'react-dom';
import Router from './router/index.js';
import reportWebVitals from './reportWebVitals';
import './util/flexible'
import './assets/base.css'

ReactDOM.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
